import { all, takeLatest } from 'lib/redux';

import {
  VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER,
  VALIDATE_SRS_BRANCH_EMPLOYEE,
} from 'constants/ActionTypes';

import {
  validateSRSBillingAffiliatedCustomerSaga,
  validateSRSBranchEmployeeSaga,
} from './SRS.saga';

export default function* watchers() {
  yield all([
    takeLatest(VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER, validateSRSBillingAffiliatedCustomerSaga),
    takeLatest(VALIDATE_SRS_BRANCH_EMPLOYEE, validateSRSBranchEmployeeSaga),
  ]);
}
